// Size buttons on premium product cards: each size is its own "add" button.
// Before the form submits, point it at the tapped size and let product-form show loading on that button.
if (!window.cardPremiumSizesReady) {
  window.cardPremiumSizesReady = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.card-premium__size-add');
    if (!button || button.disabled) return;

    const productForm = button.closest('product-form');
    const card = button.closest('.card-premium');
    if (!productForm || !card) return;

    const input = productForm.querySelector('.product-variant-id');
    if (input) {
      input.value = button.dataset.variantId;
      input.disabled = false;
    }

    productForm.submitButton = button;
    productForm.submitButtonText = button.querySelector('.card-premium__add-label');

    const spinner = productForm.querySelector('.loading__spinner');
    if (spinner && spinner.parentElement !== button) button.appendChild(spinner);

    const now = card.querySelector('[data-card-price]');
    if (now) now.textContent = button.dataset.price;

    const was = card.querySelector('[data-card-compare]');
    if (was) {
      was.textContent = button.dataset.compare || '';
      was.hidden = !button.dataset.compare;
    }
  });
}
